<script setup lang="ts">
import { overlayCva } from './consts'
import { OverlayProps } from './types'

type Props = {
  scrim?: OverlayProps['scrim']
  position?: OverlayProps['position']
  centered?: boolean
}

defineProps<Props>()

const open = defineModel<boolean>({ default: false })
</script>

<template>
  <div
    v-if="open"
    :class="overlayCva({ position, scrim, centered, class: $attrs.class })"
  >
    <slot />
  </div>
</template>
